/* eslint-disable react-native/no-inline-styles */
import React, {useMemo, useState} from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {getSubjects} from '../../../apis';
import {AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import {useAsync, useIsLandscape, wp} from '../../../utils';
import {Page} from '../../components';
import SubjectDetails from '../../SubjectDetails';
import CardsList from '../Home/components/CardsList';

const Subjects = () => {
  const isLandscape = useIsLandscape();
  const [subjectToShow, setSubjectToShow] = useState();
  const kids = useSelector((state) => state.general.kids);
  const selectedStudent = kids?.[0];

  const {loading: subjectsLoading, value: subjects} = useAsync(
    () => getSubjects(selectedStudent ? [selectedStudent.gradeId] : undefined),
    [selectedStudent],
  );

  const subjectsList = useMemo(
    () =>
      subjects
        ?.map(({id, name, languageCode, subjectType, ...rest}) => ({
          id,
          name,
          languageCode,
          subjectType,
          ...rest,
        }))
        .sort((a, b) => {
          if (a.name === b.name) {
            if (a.languageCode === b.languageCode) {
              return a.subjectType > b.subjectType ? -1 : 1;
            }
            return a.languageCode > b.languageCode ? 1 : -1;
          }
          return a.name > b.name ? 1 : -1;
        }),
    [subjects],
  );

  const subjectsToShow = isLandscape
    ? subjectsList?.map((data) => ({
        ...data,
        onPress() {
          setSubjectToShow({data});
        },
      }))
    : subjectsList;

  return (
    <>
      <Page
        header={{title: 'Teachers & Subjects', showDrawerAction: true}}
        scrollViewStyle={{maxHeight: '100%'}}>
        <View style={{maxHeight: '100%', flexDirection: 'row'}}>
          <CardsList
            selectedId={subjectToShow?.data?.id}
            loading={subjectsLoading}
            data={subjectsToShow}
            onClickRoute={AUTHENTICATED_ROUTES.subjectDetails.path}
            cardProps={{
              type: 'subject',
              primary: 'name',
              subPrimary: 'languageCode',
              secondary: 'subjectType',
              backgroundColor: '#F4EAEE',
            }}
          />
          {Boolean(subjectToShow) && (
            <View style={{width: wp(34)}}>
              <SubjectDetails
                landscapeParams={subjectToShow}
                onBackPressed={() => setSubjectToShow(undefined)}
              />
            </View>
          )}
        </View>
      </Page>
    </>
  );
};

export default Subjects;
